export interface DocumentNumberSequence {
  id: string;
  document_type: string;
  prefix: string;
  current_number: number;
  padding_length: number;
  separator: string;
  reset_on_financial_year: boolean;
  financial_year_start_month: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface DocumentNumberSequenceCreate {
  document_type: string;
  prefix: string;
  current_number?: number;
  padding_length?: number;
  separator?: string;
  reset_on_financial_year?: boolean;
  financial_year_start_month?: number;
  is_active?: boolean;
}

export interface DocumentNumberSequenceUpdate {
  prefix?: string;
  current_number?: number;
  padding_length?: number;
  separator?: string;
  reset_on_financial_year?: boolean;
  financial_year_start_month?: number;
  is_active?: boolean;
}

export enum PrinterFormat {
  REGULAR = 'regular',
  THERMAL = 'thermal',
  TALLY_PRIME = 'tally_prime'
}

export interface InvoiceTemplateConfig {
  id: string;
  template_name: string;
  document_type: string;
  printer_format: PrinterFormat;
  logo_url?: string;
  company_name: string;
  company_address: string;
  company_gstin?: string;
  company_phone?: string;
  company_email?: string;
  show_logo: boolean;
  show_company_details: boolean;
  header_text?: string;
  show_item_images: boolean;
  show_item_descriptions: boolean;
  show_hsn_codes: boolean;
  show_tax_breakdown: boolean;
  show_payment_terms: boolean;
  show_bank_details: boolean;
  show_signature_section: boolean;
  footer_text?: string;
  show_shipping_details: boolean;
  show_packing_details: boolean;
  show_transport_details: boolean;
  show_other_charges: boolean;
  terms_and_conditions?: string;
  is_default: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface InvoiceTemplateConfigCreate {
  template_name: string;
  document_type: string;
  printer_format: PrinterFormat;
  logo_url?: string;
  company_name: string;
  company_address: string;
  company_gstin?: string;
  company_phone?: string;
  company_email?: string;
  show_logo?: boolean;
  show_company_details?: boolean;
  header_text?: string;
  show_item_images?: boolean;
  show_item_descriptions?: boolean;
  show_hsn_codes?: boolean;
  show_tax_breakdown?: boolean;
  show_payment_terms?: boolean;
  show_bank_details?: boolean;
  show_signature_section?: boolean;
  footer_text?: string;
  show_shipping_details?: boolean;
  show_packing_details?: boolean;
  show_transport_details?: boolean;
  show_other_charges?: boolean;
  terms_and_conditions?: string;
  is_default?: boolean;
  is_active?: boolean;
}

export interface InvoiceTemplateConfigUpdate {
  template_name?: string;
  printer_format?: PrinterFormat;
  logo_url?: string;
  company_name?: string;
  company_address?: string;
  company_gstin?: string;
  company_phone?: string;
  company_email?: string;
  show_logo?: boolean;
  show_company_details?: boolean;
  header_text?: string;
  show_item_images?: boolean;
  show_item_descriptions?: boolean;
  show_hsn_codes?: boolean;
  show_tax_breakdown?: boolean;
  show_payment_terms?: boolean;
  show_bank_details?: boolean;
  show_signature_section?: boolean;
  footer_text?: string;
  show_shipping_details?: boolean;
  show_packing_details?: boolean;
  show_transport_details?: boolean;
  show_other_charges?: boolean;
  terms_and_conditions?: string;
  is_default?: boolean;
  is_active?: boolean;
}

export interface PaymentConfiguration {
  id: string;
  bank_name: string;
  account_number: string;
  ifsc_code: string;
  account_holder_name: string;
  branch_name?: string;
  upi_id?: string;
  upi_qr_code_url?: string;
  payment_gateway_enabled: boolean;
  payment_gateway_name?: string;
  default_payment_terms: string;
  late_payment_fee_percent?: number;
  show_on_invoice: boolean;
  show_on_estimate: boolean;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface PaymentConfigurationCreate {
  bank_name: string;
  account_number: string;
  ifsc_code: string;
  account_holder_name: string;
  branch_name?: string;
  upi_id?: string;
  upi_qr_code_url?: string;
  payment_gateway_enabled?: boolean;
  payment_gateway_name?: string;
  default_payment_terms: string;
  late_payment_fee_percent?: number;
  show_on_invoice?: boolean;
  show_on_estimate?: boolean;
  is_active?: boolean;
}

export interface PaymentConfigurationUpdate {
  bank_name?: string;
  account_number?: string;
  ifsc_code?: string;
  account_holder_name?: string;
  branch_name?: string;
  upi_id?: string;
  upi_qr_code_url?: string;
  payment_gateway_enabled?: boolean;
  payment_gateway_name?: string;
  default_payment_terms?: string;
  late_payment_fee_percent?: number;
  show_on_invoice?: boolean;
  show_on_estimate?: boolean;
  is_active?: boolean;
}

export interface ConfigurationFilters {
  document_type?: string;
  is_active?: boolean;
  is_default?: boolean;
}